import React from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import {
  required,
  validEmail,
  uniqueEmail,
  inputHasErr,
  composeValidators,
} from 'utils/validations'

const Email = () => {
  return (
    <Field
      name="email"
      validate={composeValidators(required('email'), validEmail, uniqueEmail)}
    >
      {({ input, meta }) => (
        <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
          <label className={formStyles.layerLable}>Enter your email id</label>
          <input
            data-testid="email"
            className={`${inputHasErr(meta) &&
              formStyles.inputError} form-control ${
              formStyles.formTextFreeField
            }`}
            type="email"
            {...input}
          />
          {meta.touched && meta.error && (
            <p data-testid="email_error" className={formStyles.error}>
              {meta.error}
            </p>
          )}
        </div>
      )}
    </Field>
  )
}

export default Email
